var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-one mb-4"},[_c('img',{attrs:{"src":_vm.getBannerImg,"alt":"","srcset":""}}),_c('div',{staticClass:"categories-cta-wrapper"},[_c('button',{on:{"click":function($event){$event.preventDefault();return _vm.scroll('categories')}}},[_vm._v("VIEW CATEGORIES")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }